import { Component, OnInit, Inject, Input, Output, ViewChild, SimpleChanges, EventEmitter } from '@angular/core';
import { Http } from '@angular/http';

import { NvD3Component } from 'ng2-nvd3';

declare let $: any;
declare let d3: any;

interface InputSeries {
    data: number[];
    color: string;
    title: string;
}

interface ChartSeries {
    key: string;
    color: string;
    values: DataPoint[];
}

interface DataPoint {
    label: string;
    value: number;
}

@Component({
    selector: 'graph-wide',
    templateUrl: './graph-wide.component.html',
    styleUrls: [
        './graph-wide.component.css'
        // Inclusion here matches instructions https://github.com/krispo/ng2-nvd3, but styling of chart failed
        // As workaround included css file separately in wwwroot and _Layout.cshtml
        //,'../../../../../node_modules/nvd3/build/nv.d3.css'
    ]
})
export class GraphWideComponent {
    @Input() graphTitle: string = "";
    @Input() series: Array<InputSeries> = [];
    @Input() scale: string = "";
    @Input() selectedYear: string = "";
    @Input() selectedMonth: string = "";
    @Input() selectedDay: number = 0;
    @Input() height: number = 500;

    @Input() canPrevious: boolean = false;
    @Input() canNext: boolean = false;

    @Output() previousClick = new EventEmitter<object>();
    @Output() nextClick = new EventEmitter<object>();
    @Output() barClick = new EventEmitter<object>();

    @ViewChild('nvd3') nvd3: NvD3Component | undefined;

    options: any;
    data: ChartSeries[] = [];
    depth: number = 0;

    ngOnInit() {
        // https://nvd3-community.github.io/nvd3/examples/documentation.html#multiBar
        this.options = {
            chart: {
                type: 'multiBarChart',
                height: this.height,
                margin: {
                    top: 50,
                    right: 10,
                    bottom: 60,
                    left: 60
                },
                x: function (d: any) { return d.label; },
                y: function (d: any) { return d.value; },
                reduceXTicks: false,
                staggerLabels: false,
                showLegend: true,
                showControls: false,
                xAxis: {
                    showMaxMin: false,
                    axisLabel: "tijd"
                },
                yAxis: {
                    showMaxMin: false,
                    axisLabel: this.graphTitle
                },
                noData: "Nog geen gegevens",
                valueFormat: function (d: any) {
                    return d3.format(',.2f')(d);
                },
                duration: 500
            }
        };
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['series']) {
            this.data = [];
            this.initData();
        }
    }

    initData() {
        if (this.series != undefined && this.series != null) {
            for (var i = 0; i < this.series.length; i++) {
                // Only process data if data is not already loaded
                if (this.series[i].data != undefined) {
                    this.processData(this.series[i].data, this.series[i].title, this.series[i].color);
                }
            }
        }
    }

    processData(dataAgg: number[], title: string, color: string) {
        let dataSerie = this.createChartSeries(dataAgg, title, color);

        this.data.push(dataSerie);

        if (this.nvd3 && this.nvd3.chart) {
            this.nvd3.chart.update();
        }
        let jqueryClick = this.barClick;
        let newDepth = this.depth + 1;
        let year = this.selectedYear;
        let getMonth = this.getMonthId;
        let getDay = this.getDayNumber;
        if (this.depth == 0) {
            // Currently showing a year, enable clicking month
            setTimeout(function () {
                $('nvd3 .nv-bar').unbind('click').on('click', function (target: any) {
                    jqueryClick.emit({ depth: newDepth, year: parseInt(year), month: getMonth(newDepth, target.currentTarget.__data__.label), day: -1, label: target.currentTarget.__data__.label });
                }).css('cursor', 'pointer');
            }, 750);
        }
        else if (this.depth == 1) {
            let monthLabel = this.selectedMonth;
            // Currently showing a single month, enable clicking day
            setTimeout(function () {
                $('nvd3 .nv-bar').unbind('click').on('click', function (target: any) {
                    jqueryClick.emit({ depth: newDepth, year: parseInt(year), month: getMonth(newDepth, monthLabel), day: getDay(newDepth, target.currentTarget.__data__.label), label: target.currentTarget.__data__.label });
                }).css('cursor', 'pointer');
            }, 750);
        }
        else {
            setTimeout(function () {
                $('nvd3 .nv-bar').unbind('click');
            }, 750);
        }
    }

    createChartSeries(data: number[], title: string, color: string): ChartSeries {
        let monthData = ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"];
        let seriesData: DataPoint[] = new Array<DataPoint>();        

        for (var i = 0; i < data.length; i++) {
            var label: string = "";
            if (this.scale == "year") {
                label = monthData[i];
                this.depth = 0;
                if (this.options && this.options.chart) {
                    this.options.chart.xAxis.rotateLabels = -45;
                }
            } else if (this.scale == "month") {
                label = "" + (i + 1);
                this.depth = 1;
                if (this.options && this.options.chart) {
                    this.options.chart.xAxis.rotateLabels = 0;
                }
            } else if (this.scale == "day") {
                label = i < 10 ? "0" + i : "" + i;
                label += ":00";
                this.depth = 2;
                if (this.options && this.options.chart) {
                    this.options.chart.xAxis.rotateLabels = -45;
                }
            }

            seriesData.push({
                "label": label,
                "value": data[i]
            });
        }

        return {
            "key": title,
            "color": color,
            "values": seriesData
        };
    }

    crumblePathInteraction(newDepth: number) {
        if (newDepth != this.depth) {
            if (newDepth == 0) {
                // Clicked year
                this.barClick.emit({ depth: newDepth, year: parseInt(this.selectedYear), month: -1, day: -1, label: "" });
            }
            else if (newDepth == 1) {
                // Clicked month
                let monthLabel = this.selectedMonth;
                this.barClick.emit({ depth: newDepth, year: parseInt(this.selectedYear), month: this.getMonthId(newDepth, monthLabel), day: -1, label: this.selectedMonth });
            }
        }
    }

    getMonthId(newDepth: number, targetLabel: string): number {
        let monthData = ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"];
        let result = -1;
        if (newDepth == 1 || newDepth == 2) {
            for (var i = 0; i < monthData.length; i++) {
                if (monthData[i] == targetLabel) {
                    result = i;
                    break;
                }
            }
        }
        return result;
    }

    getDayNumber(newDepth: number, targetLabel: string): number {
        if (newDepth == 2) {
            // Showing month
            return parseInt(targetLabel);
        }
        else {
            return -1;
        }
    }

    previous() {
        this.previousClick.emit();
    }

    next() {
        this.nextClick.emit();
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/pages/_shared/graph-wide/graph-wide.component.ts